export default {"src":"/_next/static/media/google.75def4b5.svg","height":18,"width":18};